<template>
  <div class="listmain ">
      <h1 class="firTitle">APNS 使用</h1>
      <span>
 <h3 class="sedTitle">注册 APNS 的 token 的接口</h3>

</span>
          <highlight-code lang="javascript">
             <span>
                 [[OrionSDK shared] registerByPushToken:@"b15a226d78ed41552c3340799ad9249b3012addcdc4ade432a732098e378ad2f" completion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
        NSLog(@"%@,%@",conversationInfo,error);
    }];
             </span>
    </highlight-code>
      <h3 class="sedTitle">Push 内容内部处理方法</h3>

      <highlight-code lang="javascript">
         <span>
             /**
 *  @brief 处理远程Push的内容
 *  @param userInfo 远程Push的内容
 */

- (NSDictionary * __nullable)handlerRemoteNotification:(NSDictionary * __nullable)userInfo;

         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
              返回状态结构如下：
          </span>
      </p>

      <highlight-code lang="javascript">
         <span>
             @{
    @"code":@904,//200正常，其他都是错误，无法处理903是无法处理，904是未登录
    @"data":@{
        @"desc":@"账户未登录"
    }
};
         </span>
      </highlight-code>

      <h3 class="sedTitle">自己模拟处理 APNS 的消息自测方法</h3>

      <highlight-code lang="javascript">
         <span>
             // 先把json格式转换成encode base64编码
NSString *jsonStringBase64PushType11 = @"ewogICJhcHMiOiB7CiAgICJjb250ZW50LWF2YWlsYWJsZSI6MQogIH0sCiAgImRhdGEiOiB7CiAgICAiY29kZSI6IDIwMCwKICAgICJ0ZXh0IjogIkJpelVzZXItcHVzaFF1ZXJ5SGlzdG9yeSIsCiAgICAiZG9tYWluIjogIkJpelVzZXIiLAogICAgImVuZ2xpc2hfZG9tYWluIjogIkJpelVzZXIiLAogICAgImludGVudCI6ICJwdXNoUXVlcnlIaXN0b3J5IiwKICAgICJkYXRhIjogewogICAgICAiaGlzdG9yeVNjZW5lVHlwZSI6IDAsCiAgICAgICJoaXN0b3J5SWQiOiAzNzIzCiAgICB9CiAgfQp9";
// decode base64编码，并转换成字典
NSString *dataString = [jsonStringBase64PushType11 ovs_base64DecodedString]; NSDictionary *dict = [NSJSONSerialization JSONObjectWithData:[dataString dataUsingEncoding:NSUTF8StringEncoding] options:NSJSONReadingMutableContainers error:nil];
// 调用Push的framework处理方法处理
NSLog(@"1.1:%@",[[OrionSDK shared] handlerRemoteNotification:dict]);
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
             NOTE：<br>
1. 使用原则，如果宿主应该尽量判断是否能够处理Push信息后，再抛入PushSDK处理，以减少异常的发生。<br>
2. 因为兼容版本等问题：接收到的数据，Push的SDK是尽量给出是否能够处理的状态码，不保证100%判断正常，处理不了的会丢掉<br>
          </span>
      </p>
      <h3 class="sedTitle">Push 的结构解释</h3>

      <highlight-code lang="javascript">
         <span>
             附录：Push的结构解释
{
  "aps": {
   "...":"..."
  },
  "data": {//Push需要处理的数据
    "code": 200,
    "...": "..."//其他扩展字段
    "data": {
      "historySceneType": 0,//支付的Push类型
      "pushType": 2,//Push类型
      "...": "..."//其他扩展字段
    }
  }
}
         </span>
      </highlight-code>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/APNS.vue